import { FilterNumberInput } from "components/FilterNumberInput";
import { useField } from "lib/form";
import React, { ReactElement } from "react";

export const FilterPriceMax = ({ isMobile }: { isMobile?: boolean }): ReactElement => {
    const [valueMax, , onMaxChange] = useField("maximumprijs");

    return (
        <FilterNumberInput
            filterId="maximumprijs"
            position={isMobile ? "left" : "center"}
            handleChange={(_: any, price: string) => onMaxChange(price)}
            value={valueMax}
            datalayerKey="prijs.max"
            classes={`home-price ${isMobile ? "left" : ""}`}
            ariaLabel="Prijs tot"
            withPrefix
            numeric
        />
    );
};
